import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2 } from "lucide-react";
import AuthLayout from "./AuthLayout";
import { api, apiError } from "@/lib/api";
import { Field, ErrorState } from "@/components/common";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [err, setErr] = useState(token ? "" : "This reset link is missing its token.");

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 8) return setErr("Password must be at least 8 characters.");
    if (pw !== pw2) return setErr("Passwords do not match.");
    setBusy(true); setErr("");
    try { await api.post("/auth/reset-password", { token, password: pw }); setDone(true); }
    catch (e2) { setErr(apiError(e2)); } finally { setBusy(false); }
  };

  return (
    <AuthLayout title="Choose a new password" subtitle="All other sessions will be signed out.">
      {done ? (
        <div data-testid="reset-password-success" className="space-y-5">
          <div className="flex gap-3 p-4 rounded-xl border border-[#4BE3A4]/30 bg-[#4BE3A4]/5 text-sm text-[#F7FAFF]">
            <CheckCircle2 size={16} className="text-[#4BE3A4] mt-0.5" /> Your password has been updated.
          </div>
          <Link data-testid="reset-go-login" to="/login" className="cq-btn cq-btn-primary w-full">Sign in</Link>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="reset-password-form">
          <Field label="New password"><input data-testid="reset-password-input" type="password" className="cq-input" value={pw} onChange={(e) => setPw(e.target.value)} /></Field>
          <Field label="Confirm password"><input data-testid="reset-password-confirm-input" type="password" className="cq-input" value={pw2} onChange={(e) => setPw2(e.target.value)} /></Field>
          {err && <ErrorState message={err} testId="reset-error" />}
          <button data-testid="reset-submit-button" disabled={busy || !token} className="cq-btn cq-btn-primary w-full !py-2.5">
            {busy && <Loader2 size={14} className="animate-spin" />} Update password
          </button>
        </form>
      )}
    </AuthLayout>
  );
}
